import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

const Unauthorized = () => {
  const { t } = useTranslation('common');
  const { currentUser, userInfo } = useAuth();

  const getUserName = () => {
    if (userInfo?.user?.name) return userInfo.user.name;
    return currentUser?.email || t('unauthorized_fallback_user');
  };

  const getUserRole = () => {
    if (userInfo?.user?.members && userInfo.user.members.length > 0) {
      return userInfo.user.members[0]?.role || t('unauthorized_fallback_user');
    }
    return t('unauthorized_fallback_user');
  };

  const getUserOrganization = () => {
    if (userInfo?.user?.members && userInfo.user.members.length > 0) {
      return userInfo.user.members[0]?.organization?.name || t('unauthorized_no_org');
    }
    return t('unauthorized_no_org');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 p-6 text-center">
      <div className="text-6xl mb-6">🔒</div>
      <h1 className="text-3xl font-bold text-red-400 dark:text-red-500 dark:text-red-400 mb-4">{t('unauthorized_title')}</h1>
      <p className="text-gray-300 max-w-md mb-8">
        {t('unauthorized_message')}
      </p>

      {currentUser && (
        <div className="bg-gray-800 p-4 rounded-lg mb-8 inline-block text-left">
          <h2 className="text-xl text-blue-400 dark:text-blue-500 dark:text-blue-400 mb-2">{t('unauthorized_access_level')}</h2>
          <p className="text-gray-300">
            <span className="font-semibold">{t('unauthorized_user')}:</span> {getUserName()}<br />
            <span className="font-semibold">{t('unauthorized_role')}:</span> {getUserRole()}<br />
            <span className="font-semibold">{t('unauthorized_organization')}:</span> {getUserOrganization()}
          </p>
        </div>
      )}

      <div className="flex space-x-4">
        <Link
          to="/dashboard"
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
        >
          {t('unauthorized_return_dashboard')}
        </Link>
        <Link
          to="/firebase-login"
          className="px-4 py-2 bg-gray-700 text-gray-300 rounded hover:bg-gray-600 transition-colors"
        >
          {t('unauthorized_change_user')}
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized; 